import * as React from 'react';
import { Modal, Button } from 'kui';
import './_DrivePermissionsErrorModal.scss';
import {
    IDrivePermissionsErrorModalProps
} from './types';
import { ESourceValue } from '../../../permissionsFAQModal/constants';
import { TITLE } from './constants';

export function DrivePermissionsErrorModal ({
    error,
    onClick,
    onClose,
}: IDrivePermissionsErrorModalProps) {
    const className = 'drive-permissions-error';
    const classLink = className + '__link';

    return (
        <Modal
            title={TITLE}
            variant={'actions'}
            className={className}
            onClose={onClose}
        >
            <p className={className + '__text'}>
                {error}
            </p>
            <p className={className + '__text'}>
                For more information, <a className={classLink} href={'https://www.kanbanchi.com/faqwd/permissions'} target={'_blank'} onClick={() => onClick(ESourceValue.FAQ)}>visit our FAQ </a> <br/>or <a className={classLink} href={'https://www.kanbanchi.com/contacts'} target={'_blank'} onClick={() => onClick(ESourceValue.CONTACT)}>contact our support team</a> for assistance.
            </p>
            <Button
                className={className + '__button'}
                onClick={onClose}
            >OK</Button>
        </Modal>
    );
}
